// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"TrialHeader_headerContainer__b8lVZ","heroWrapper":"TrialHeader_heroWrapper__h82ri"};